import { AddEdit } from '../../../../../interfaces/vendor.interface';
import { Validation } from '../../../../../interfaces/common';
import { APP_ERROR_MESSAGES, VALIDATION_FIELD_MAPPING, Regex, MaxLength } from '../../../../../utils/appConstant';

export const validateAddEditForm = (formData: AddEdit, fieldToValidate?: string) => {
  const validations: Validation = { validate: true, fields: [] };

  if (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.companyName) { 
    if (formData.companyName?.trim()?.length > MaxLength.common) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.companyName,
        message: APP_ERROR_MESSAGES.vendors.addEdit.maxLengthExceeded
      });
    }
  }

  if (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.name) {
    if (!formData.name?.trim()) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.name,
        message: APP_ERROR_MESSAGES.vendors.addEdit.blankVendorName
      });
    } else if (formData.name.trim().length > MaxLength.common) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.name,
        message: APP_ERROR_MESSAGES.vendors.addEdit.maxLengthExceeded
      });
    }
  }

  if (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.email) {
    if (formData.email?.trim() && !Regex.email.test(formData.email.trim())) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.email,
        message: APP_ERROR_MESSAGES.vendors.addEdit.invalidEmail
      });
    }
  }

  if (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.phoneNumber) {
    if (!formData.phoneNumber?.trim()) { validations.validate = false; validations.fields.push({ field: VALIDATION_FIELD_MAPPING.phoneNumber, message: APP_ERROR_MESSAGES.vendors.addEdit.blankPhoneNumber }) }
  }

  if (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.serviceType) {
    if (!formData.serviceTypeId) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.serviceType,
        message: APP_ERROR_MESSAGES.vendors.addEdit.blankServiceType
      });
    }
  }

  if (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.serviceRate) {
    const value = formData.serviceRate as any;

    if (value && value.trim()) {
      if (!Regex.floatValues.test(value)) {
        validations.validate = false;
        validations.fields.push({
          field: VALIDATION_FIELD_MAPPING.serviceRate,
          message: APP_ERROR_MESSAGES.vendors.addEdit.invalidServiceRate
        });
      } else {
        const numValue = parseFloat(value);
        if (numValue <= 0) {
          validations.validate = false;
          validations.fields.push({
            field: VALIDATION_FIELD_MAPPING.serviceRate,
            message: APP_ERROR_MESSAGES.vendors.addEdit.invalidServiceRate
          });
        }
      }
    }
  }

  if (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.phoneNumber) {
    if (formData.phoneNumber && formData.phoneNumber.trim().length > MaxLength.common) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.phoneNumber,
        message: APP_ERROR_MESSAGES.vendors.addEdit.maxLengthExceeded
      });
    }
  }

  return validations;
};
